import script from "./backBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./backBtn.vue?vue&type=script&setup=true&lang=js"

import "./backBtn.vue?vue&type=style&index=0&id=4ccc1797&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ccc1797"]])

export default __exports__